import { useEffect, useState } from 'react';

const useResizeObserver = (widthScreen: number) => {
  const [isVisible, setIsVisible] = useState(() => window.innerWidth >= widthScreen);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentBoxSize) {
          // older browsers report a single box instead of an array
          const boxSize: ResizeObserverSize | readonly ResizeObserverSize[] = entry.contentBoxSize;
          const contentBoxSize = (
            Array.isArray(boxSize) ? boxSize[0] : boxSize
          ) as ResizeObserverSize;
          if (contentBoxSize.inlineSize <= widthScreen || entry.contentRect.width <= widthScreen) {
            setIsVisible(false);
          } else {
            setIsVisible(true);
          }
        }
      }
    });

    const resizeHandler = () => {
      if (document.body) {
        resizeObserver.observe(document.body);
        return () => resizeObserver.unobserve(document.body);
      } else {
        setIsVisible(window.innerWidth >= widthScreen);
      }
    };

    window.addEventListener('resize', resizeHandler);
    resizeHandler();
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [widthScreen]);

  return isVisible;
};

export default useResizeObserver;
